import {rankPlants} from './plant-ranking.mjs';
export const PRIMARY_CULTURES=['tomat','perets','ogurets','kapusta','kabachok','zemlyanika-i-klubnika'];
export const OVERVIEW_CULTURES=[...PRIMARY_CULTURES,'tykva','redis'];
const names={tomat:['Томаты','томатов'],perets:['Перцы','перцев'],ogurets:['Огурцы','огурцов'],kapusta:['Капуста','капусты'],kabachok:['Кабачки','кабачков'],'zemlyanika-i-klubnika':['Земляника','земляники'],tykva:['Тыквы','тыкв'],redis:['Редис','редиса'],salat:['Салаты','салатов'],rozy:['Розы','роз']};
export const cultureName=c=>names[c.slug]?.[0]||c.title;
export const cultureHeading=c=>names[c.slug]?'Рейтинг '+names[c.slug][1]:'Рейтинг: '+c.title;
export function ratingCultures(plants){
 const groups=new Map();
 for(const p of plants){if(!p.category?.slug)continue;const key=p.category.slug;if(!groups.has(key))groups.set(key,{...p.category,plants:[]});groups.get(key).plants.push(p)}
 return [...groups.values()].map(c=>{
  // A prior and an order are computed independently for each culture, never globally.
  const ranked=rankPlants(c.plants).all.sort((a,b)=>Number(b.eligible)-Number(a.eligible)||b.score-a.score||a.id-b.id);
  return {...c,name:cultureName(c),heading:cultureHeading(c),plants:ranked,count:ranked.length,reviews:ranked.reduce((n,p)=>n+p.reviewCount,0)};
 }).sort((a,b)=>{const ai=OVERVIEW_CULTURES.indexOf(a.slug),bi=OVERVIEW_CULTURES.indexOf(b.slug);return(ai<0?999:ai)-(bi<0?999:bi)||b.count-a.count||a.id-b.id});
}
export function plantAwardIndex(plants){
 const result={};
 for(const c of ratingCultures(plants)){
  const maximum=Math.max(...c.plants.map(p=>p.reviewCount));
  for(const p of c.plants){const badges=[];
   if(p.authors>=3&&p.reviewCount===maximum)badges.push({id:'reviews',title:'Лидер по отзывам',basis:`Больше всего опубликованных отзывов в культуре «${c.name}»: ${p.reviewCount}. Не менее трёх авторов; при равенстве отмечены все сорта.`});
   if(p.authors>=5&&Number.isFinite(p.authorRating)&&p.authorRating<=5&&p.authorRating+1e-9>=4.8)badges.push({id:'ratings',title:'Высокие оценки',basis:`Средняя последних оценок авторов ${p.authorRating.toLocaleString('ru-RU',{maximumFractionDigits:2})} из 5; авторов: ${p.authors}. Условие: от 4,8 и не менее пяти авторов.`});
   if(badges.length)result[p.id]=badges;
  }
 }
 return result;
}

export const varietyCount=n=>n.toLocaleString('ru-RU')+' '+(n%10===1&&n%100!==11?'сорт':n%10>=2&&n%10<=4&&(n%100<12||n%100>14)?'сорта':'сортов');
